<template>
  <div class="local-track-container">
    <video ref="videoElem" width="240px" autoPlay="true" playsInline="true" muted />
  </div>
</template>
<script>
/**
 * Displays the own video tile
 * @displayName Me
 */
import { mapState } from "vuex";

export default {
  name: "Me",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapState({
      changedWebcamTrack: (state) => state.mediasoup.changedWebcamTrack,
    }),
  },
  watch: {
    changedWebcamTrack(val) {
      if (val) {
        const stream = new MediaStream();
        let videoProducer = this.$store.getters["mediasoup/videoProducer"];
        stream.addTrack(videoProducer.track);
        console.log("mestream", stream.getTracks());
        this.$nextTick(function () {
          this.$refs.videoElem.srcObject = stream;
          this.$refs.videoElem.play().catch((error) => console.log("videoElem.play() failed:%o", error));
        });
        this.$store.commit("mediasoup/changedWebcamTrack", false);
      }
    },
  },
  created() {
    const stream = new MediaStream();
    let videoProducer = this.$store.getters["mediasoup/videoProducer"];
    stream.addTrack(videoProducer.track);
    console.log("mestream", stream.getTracks());
    this.$nextTick(function () {
      this.$refs.videoElem.srcObject = stream;
      this.$refs.videoElem.play().catch((error) => console.log("videoElem.play() failed:%o", error));
    });
  },
};
</script>
